import { Link } from "react-router-dom";
import { 
  MapPin, Phone, Star, ShieldCheck,
  Wrench, Zap, Trees, Sparkles, Fan, Home, Paintbrush, Square, 
  Hammer, Layers, Boxes, PanelTop, Lock, Bug, Refrigerator,
  Fence, Trash2, Shovel, DoorOpen
} from "lucide-react";
import { RatingDisplay } from "./StarRating";
import { Badge } from "./ui/badge";

// Map category IDs to icons
const categoryIconMap = {
  cat_plumbing: Wrench,
  cat_electrical: Zap,
  cat_landscaping: Trees,
  cat_cleaning: Sparkles,
  cat_hvac: Fan,
  cat_roofing: Home,
  cat_painting: Paintbrush,
  cat_flooring: Square,
  cat_carpentry: Hammer,
  cat_drywall: Layers,
  cat_masonry: Boxes,
  cat_glass: PanelTop,
  cat_locksmith: Lock,
  cat_pest: Bug,
  cat_appliance: Refrigerator,
  cat_fencing: Fence,
  cat_demolition: Trash2,
  cat_excavation: Shovel,
  cat_garage: DoorOpen,
  cat_handyman: Wrench,
};

export const ServiceCard = ({ service, featured = false }) => {
  const CategoryIcon = categoryIconMap[service.category_id] || Wrench;
  
  return (
    <Link
      to={`/service/${service.service_id}`}
      className={`group block bg-white rounded-2xl border overflow-hidden transition-all duration-300 hover:shadow-lg hover:border-[#1A4D2E]/30 card-hover ${
        featured ? "border-[#E07A5F]" : "border-stone-200"
      }`}
      data-testid={`service-card-${service.service_id}`}
    >
      {/* Image or Category Icon */}
      <div className="relative h-48 overflow-hidden bg-stone-100">
        {service.image_url ? (
          <img
            src={service.image_url}
            alt={service.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#1A4D2E]/10 to-[#1A4D2E]/20">
            <div className="w-20 h-20 bg-[#1A4D2E]/10 rounded-2xl flex items-center justify-center group-hover:bg-[#1A4D2E]/20 transition-colors">
              <CategoryIcon className="w-10 h-10 text-[#1A4D2E]" />
            </div>
          </div>
        )}
        
        {/* Featured Badge */}
        {service.is_featured && (
          <div className="absolute top-3 left-3">
            <Badge className="bg-[#E07A5F] text-white border-0">
              <Star className="w-3 h-3 mr-1 fill-current" />
              Featured
            </Badge>
          </div>
        )}
        
        {/* Verified Badge */}
        {service.is_approved && (
          <div className="absolute top-3 right-3">
            <div className="bg-white/90 backdrop-blur-sm rounded-full p-1.5">
              <ShieldCheck className="w-4 h-4 text-[#1A4D2E]" />
            </div>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="font-semibold text-lg text-[#1A1A1A] mb-2 group-hover:text-[#1A4D2E] transition-colors line-clamp-1">
          {service.name}
        </h3>
        
        <p className="text-[#4A4A4A] text-sm mb-3 line-clamp-2">
          {service.description}
        </p>

        <div className="flex items-center gap-2 text-[#71717A] text-sm mb-3">
          <MapPin className="w-4 h-4 flex-shrink-0" />
          <span className="line-clamp-1">{service.city}</span>
        </div>

        <div className="flex items-center justify-between">
          <RatingDisplay
            rating={service.average_rating || 0}
            reviewCount={service.review_count || 0}
            size="sm"
          />
          
          <span className="text-[#1A4D2E] font-medium text-sm group-hover:underline">
            View Details
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
